import { OfferWrapper } from 'generated/api'
import { useAnalytics } from 'services/AnalyticsLite/useAnalytics'
import AnalyticsService from 'services/AnalyticsLite/AnalyticsService'
import { VoidCallback } from 'types/index'
import { ViewMode } from '../FilterableResults/FilterableResults'
import { OfferRecommendation } from 'experiences/search/Results/services/recommendations'
import { GoogleAdsClient } from 'services/AnalyticsLite/Ads'
import { ga4Client } from 'services/AnalyticsLite/GA4/utils/client'

export const trackOfferClick = async (offer: OfferWrapper) => {
	ga4Client.eventsClient.trackEvent(getOfferEventName(offer), {
		value: (offer?.recommendation?.classicRecScore || 0) / 100
	})
	return GoogleAdsClient.offerClick(offer)
}
export const useFilteredResultsAnalytics = () => {
	const { track } = useAnalytics('filtered_results')
	const trackViewSelected = (view: ViewMode, callback: VoidCallback) =>
		track('view_selected', { label: view }, callback)
	const trackOfferRedirect = (callback?: VoidCallback) => track('offer_redirect_fired', {}, callback)
	const trackFilterVisible = (userInitiated?: boolean) =>
		track('filter_visible', { label: userInitiated ? 'user_initiated' : 'always_visible' })
	const trackFilterAdjustment = (filterName: string) => track('filter_adjusted', { label: filterName })

	const trackRecommendationClick = (offer: OfferWrapper, recommendation: OfferRecommendation) =>
		track('recommended_offer_clicked', {
			label: recommendation.title
		})
	const trackResultsShown = (searchId: string) => track('results_shown', { label: searchId })

	return {
		trackOfferClick,
		trackViewSelected,
		trackOfferRedirect,
		trackFilterAdjustment,
		trackFilterVisible,
		trackResultsShown,
		trackRecommendationClick
	}
}

const getOfferEventName = (offer: OfferWrapper) => {
	switch (offer.sourceType) {
		case 'simple':
			return 'special_offer_click'
		case 'loan':
			return 'loan_offer_click'
		case 'life_insurance':
			break
		case 'credit_card':
			break
	}
	return `inferred_offer_click_${offer.sourceType}`
}

let lastFilterAdjusted: string
export const trackFilterAdjustment = (filterName: string): void => {
	if (lastFilterAdjusted !== filterName) {
		lastFilterAdjusted = filterName
		AnalyticsService.track('filter_adjusted', { label: filterName, category: 'filtered_results' })
	}
}
